export default "__VITE_ASSET__0b107ad7__"